module.exports = __webpack_public_path__ + "img/TETHER.55f9146a.svg";